const multibookConfig = require(`../../../package.json`).config;

let homeBookStyle = {
  bcg: require('./book/assets/bcg.png'),
  multibooks: [
    {
      bcg: require('./book/assets/00.png'),
      name: 'fun-time',
      title: 'J. angielski',
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '23%',
        left: '4.4%',
        width: '26.2%',
      },
    },
    {
      bcg: require('./book/assets/units.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'units-grid-view',
      title: 'units',
      items: require(`./book/assets/items/units.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '30.5%',
        left: '30.12%',
        width: '23%',
      },
    },
    {
      bcg: require('./book/assets/festivals.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'festivals-grid-view',
      title: 'festivals',
      items: require(`./book/assets/items/festivals.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '37%',
        left: '50.2%',
        width: '23%',
      },
    },
    {
      bcg: require('./book/assets/revise.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'revise-grid-view',
      title: 'revise',
      items: require(`./book/assets/items/revise.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '43.5%',
        left: '70.3%',
        width: '23%',
      },
    },
    {
      bcg: require('./book/assets/nagrania.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'nagrania-grid-view',
      title: 'nagrania',
      // items: require(`./book/assets/items/nagrania.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '51.3%',
        left: '36.65%',
        width: '25%',
      },
    },
    {
      bcg: require('./book/assets/plakaty.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'plakaty-grid-view',
      title: 'plakaty',
      items: require(`./book/assets/items/plakaty.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '61.6%',
        left: '45.25%',
        width: '25%',
      },
    },
    {
      bcg: require('./book/assets/karty.png'),
      name: 'fun-time',
      type: 'fun-time',
      router: 'karty-grid-view',
      title: 'karty',
      items: require(`./book/assets/items/karty.js`).default,
      mask: '0% 0%, 100% 0%, 100% 100%, 0% 100%',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '71.5%',
        left: '53%',
        width: '25%',
      },
    },
  ],
  text: [
    // {
    //   content: 'Multibook',
    //   cssStyle: {
    //     position: 'absolute',
    //     top: '18%',
    //     left: '0%',
    //     color: '#1647a0',
    //     fontSize: '33px',
    //     fontFamily: 'Lato Light',
    //     textAlign: 'center',
    //     width: '48%',
    //   },
    // },
    // {
    //   content: 'Dodatkowe materiały dla nauczyciela',
    //   cssStyle: {
    //     position: 'absolute',
    //     top: '34%',
    //     left: '40%',
    //     color: '#1647a0',
    //     fontSize: '24px',
    //     fontFamily: 'Lato Light',
    //     textAlign: 'center',
    //     width: '50%',
    //   },
    // },
    // {
    //   url: 'https://www.mac.pl',
    //   content:
    //     'Rozkład materiału i plan wynikowy w wersji Word dostępne są na stronie <u style="color: #3861ac; cursor: pointer">www.mac.pl</u>',
    //   cssStyle: {
    //     position: 'absolute',
    //     bottom: '1%',
    //     color: '#a59d9a',
    //     fontSize: '16px',
    //     fontFamily: 'Lato',
    //     width: '100%',
    //     textAlign: 'center',
    //     zIndex: '20',
    //   },
    // },
  ],
};

let home;
switch (multibookConfig.launcherType) {
  case 'book':
  default:
    home = homeBookStyle;
    break;
}
export default home;
